import { Row } from "@tanstack/react-table";
import { FileText, Trash2 } from "lucide-react";
import { useSelector } from "react-redux";
import { toast } from "sonner";

import { useConsumedColumns } from "./ConsumedTableColumns";

import { CustomTable } from "@/components/reusables/data-table/CustomTable";
import { ToolsConstants } from "@/constants/tools.constant";
import { ResponsePagination } from "@/hooks/usePagination";
import { GlobalRowDataTypes } from "@/interfaces/global-table.interface";
import { Permissions } from "@/interfaces/globals";
import {
  IProductConsumed,
  IProductLogsItem,
} from "@/interfaces/tools.interface";
import { hasWritePermission } from "@/redux/slices/permissionSlice";

interface ProductTableProps {
  data: IProductConsumed[];
  pagination: ResponsePagination;

  toggleViewLogSheet: React.Dispatch<
    React.SetStateAction<{
      isOpen: boolean;
      itemName: string;
      data: IProductLogsItem[];
    } | null>
  >;
}

const ConsumedTable = ({
  data,
  pagination,
  toggleViewLogSheet,
}: ProductTableProps): JSX.Element => {
  const getActionOptions = (
    row: Row<IProductConsumed>,
  ): ActionButtonDataTypes[] => [
    {
      icon: FileText,
      name: "View Log",
      onclick: (): void => {
        toggleViewLogSheet({
          isOpen: true,
          itemName: row.original.name,
          data: row.original.logs || [],
        });
      },
    },

    {
      icon: Trash2,
      name: "Move to Trash",
      isTrash: true,
      onclick: (): void => {
        toast.info("Edit Ticket");
      },
    },
  ];

  const writePermissions = useSelector(hasWritePermission(Permissions.TOOLS));

  const columns = useConsumedColumns({
    getActions: getActionOptions,
    writePermissions,
    toggleViewLogSheet,
  });

  return (
    <CustomTable
      empty={{}}
      columns={columns}
      data={data}
      title={ToolsConstants.INDEX_CONTENT_TEXT.PRODUCT_HEADER}
      hasWritePermission={writePermissions}
      functions={{
        isExport: true,
        columnToggle: true,
        search: ToolsConstants.INDEX_CONTENT_TEXT.PRODUCT_HEADER,
        RightClickData: (
          row: GlobalRowDataTypes<IProductConsumed>,
        ): ActionButtonDataTypes[] =>
          getActionOptions(row as Row<IProductConsumed>),
        pagination,
      }}
      hide={{
        filters: true,
        functions: true,
      }}
    />
  );
};

export default ConsumedTable;
